<div
    [ngClass]="{
        'blank-page':
            router.url === '/error-500' ||
            router.url === '/coming-soon'
    }"
>
    @if(!isLoginPage()) {
    <div
        class="main-content d-flex flex-column"
        [ngClass]="{ active: isToggled }"
    >
        <app-header />
        <router-outlet />
        <div class="flex-grow-1"></div>
        <!-- <app-footer /> -->
    </div>
    }
    @else {
        <router-outlet />
    }
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.6)" size = "default" color = "#fff" type = "ball-climbing-dot" [fullScreen] = "true">
        <p style="color: white" > Loading... </p>
    </ngx-spinner>
</div>
